export const B2B_CHECK_ORGANIZATION_NAME = "B2B_CHECK_ORGANIZATION_NAME";
export const B2B_CHECK_ORGANIZATION_NUMBER = "B2B_CHECK_ORGANIZATION_NUMBER";
export const B2B_SET_BUSINESS_DETAILS = "B2B_SET_BUSINESS_DETAILS";
export const B2B_SET_SHOULD_SHOW_ORG_OR_NAME_INPUT = "B2B_SET_SHOULD_SHOW_ORG_OR_NAME_INPUT";
export const B2B_SET_SHOULD_SHOW_INPUT_FIELDS = "B2B_SET_SHOULD_SHOW_INPUT_FIELDS";
export const B2B_SET_SHOULD_SHOW_PB_FIELDS = "B2B_SET_SHOULD_SHOW_PB_FIELDS";
export const B2B_SUBMIT_BUSINESS_DETAILS = "B2B_SUBMIT_BUSINESS_DETAILS";
export const B2B_SUBMIT_MANUAL_ORDER = "B2B_SUBMIT_MANUAL_ORDER";
// export const B2B_SUBMIT_PRODUCT_AND_PRODUCTUSER = "B2B_SUBMIT_PRODUCT_AND_PRODUCTUSER";
